/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Gender_Vrouw2Inputs */

const nl_enums_gender_vrouw2 = /** @type {(inputs: Enums_Gender_Vrouw2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vrouw`)
};

/**

* @param {Enums_Gender_Vrouw2Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_gender_vrouw2 = /** @type {((inputs?: Enums_Gender_Vrouw2Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Gender_Vrouw2Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_gender_vrouw2(inputs)
});
export { enums_gender_vrouw2 as "enums.Gender.Vrouw" }